import { useDispatch, useSelector } from "react-redux";
import SharedDiv from "../../../Components/SharedDiv/SharedDiv";
import TextAreaAHSF from "../../../Components/TextAreaAHSF";
import ProjectInformationPage from "../../../Containers/ProjectInformationPage";
import InformationTargetGroupProjectTable from "./InformationTargetGroupProjectTable";
import JordanianGovernoratesProjectActivitiesTable from "./JordanianGovernoratesProjectActivitiesTable";
import PalestinianGovernoratesProjectActivitiesTable from "./PalestinianGovernoratesProjectActivitiesTable";
import { useEffect, useState } from "react";
import {
  GetTargetInfo,
  SetMainTargetedGroup,
  ValidateMainTargetedGroup,
} from "../../../Redux/Reducers/ProjectInformationPage/InformationAboutTheTargetGroupOfTheProject";
import LoaderAHSF from "../../../Components/LoaderAHSF";
import { getAllCountryOfProjectImplementation } from "../../../Redux/Reducers/DropDownApplicationInformation";
import { GetProjectInformation } from "../../../Redux/Reducers/ProjectInformationPage/ProjectInformation";
import UpdateGenderMainstreaming from "../../../Services/ProjectInformationPage/InformationAboutTheTargetGroup/UpdateGenderMainstreaming";
import ButtonAHSF from "../../../Components/ButtonAHSF";
import { useNavigate, useParams } from "react-router-dom";
import Swal from "sweetalert2";
import loadConfig from "../../../Services/apiService";
import PopupAHSF from "../../../Components/PopupAHSF";
import { decryptToken } from "../../../Services/Account/EncryptionParams";

const InformationTargetGroupProjectModule = () => {
  const dispatch = useDispatch();
  const state = useSelector((state) => {
    return {
      TargetInfo: state.TargetInfo.TargetInfo,
      ApplicationInformation:
        state.ApplicationInformation.ApplicationInformation,
      loadingGetTargetInfo: state.TargetInfo.loadingGetTargetInfo,
      ProjectInformation: state.ProjectInformation.ProjectInformation,
      countryOfProjectImplementation:
        state.dropDownApplicationInformation.countryOfProjectImplementation,
      MainTargetedGroupValidate: state.TargetInfo.MainTargetedGroupValidate,
      ActiveRound: state.ApplicationInformation.ActiveRound,
      loadingUpdateInfoAboutProject:
        state.ProjectInformation
          .ProjectInformationloadingUpdateInfoAboutProject,
    };
  });
  //console.log(state.MainTargetedGroupValidate, "ddd");
  const navigate = useNavigate();
  const AppGuid = useParams();

  const [TargetGroupProject, setTargetGroupProject] = useState({
    // genderInclusionPlan: state.TargetInfo?.genderInclusionPlan,
    // nameCountryWhichProjectWillBeImplemented:
    //   state.ProjectInformation?.nameCountryWhichProjectWillBeImplemented,
    // countryOfProjectImplementation:
    //   state.dropDownApplicationInformation?.countryOfProjectImplementation,
    ...state.TargetInfo,
  });
  const [dataJsonObject, SetDataJsonObject] = useState();
  const [isPopupOpenStatus, setisPopupOpenStatus] = useState(false);
  const dataJson = async () => {
    let jsonData = await loadConfig();
    SetDataJsonObject(jsonData);
    //console.log(jsonData, "jsonData");
  };
  //console.log(state.TargetInfo?.genderInclusionPlan);

  useEffect(() => {
    dispatch(
      GetProjectInformation(
        state.ApplicationInformation.aI_ApplicationInformationId||
        decryptToken(AppGuid.AppGuid)
      )
    );
    dispatch(
      GetTargetInfo(state.ApplicationInformation.aI_ApplicationInformationId||
        decryptToken(AppGuid.AppGuid))
    );
  }, []);
  // Save data and optionally validate
  const SaveDataPage = async (withValidate) => {
    const saved = await UpdateGenderMainstreaming(
      state.TargetInfo?.tG_MainTargetedGroupId,
      TargetGroupProject.genderInclusionPlan,
      TargetGroupProject.aI_ApplicationInformationId
    );
    if (withValidate == true && saved) {
      const validate = await dispatch(
        ValidateMainTargetedGroup(state.TargetInfo.aI_ApplicationInformationId)
      );
      if (validate.payload.length === 0) {
        Swal.fire({
          position: "center",
          icon: "success",
          title: "تم حفظ المعلومات بنجاح",
          showConfirmButton: false,
          timer: 1500,
          // width: "500px",
        });
        navigate("/grants/InformationProject/projectPlan");
      } else {
        setisPopupOpenStatus(true);
      }
    }
  };
  // Update local state when data is loaded
  useEffect(() => {
    if (!state.loadingGetTargetInfo) {
      setTargetGroupProject({ ...state.TargetInfo });
    }
  }, [state.loadingGetTargetInfo]);
  // Update the main targeted group in Redux whenever the local state changes
  useEffect(() => {
    if (!state.loadingUpdateInfoAboutProject) {
      setTargetGroupProject({ ...state.TargetInfo });
    }
  }, [state.loadingUpdateInfoAboutProject]);

  useEffect(() => {
    dispatch(SetMainTargetedGroup({ ...TargetGroupProject }));
  }, [TargetGroupProject]);

  const shouldDisableFields = !(
    state.ApplicationInformation?.aI_ApplicationStatusId == "bbad6edf-0d73-4478-b33d-68f9c777d438"&&!window.location.href.includes("manager") ? true :
      state.ActiveRound === state.ApplicationInformation?.aI_RoundYearId &&
      state.ApplicationInformation?.aI_ApplicationStatus?.canEdite &&
      !window.location.href.includes("manager")
  );


  return (
    <>
      <ProjectInformationPage active={1} />
      {!state.loadingUpdateInfoAboutProject ? (
        <>
          <SharedDiv
            showTitle={true}
            titleName=" معلومات عن الفئة المستهدفة ضمن المشروع"
            child={[
              <>
                <InformationTargetGroupProjectTable
                  tG_MainTargetedGroupId={
                    state.TargetInfo?.tG_MainTargetedGroupId
                  }
                />
                <div className="form-grid">
                  <TextAreaAHSF
                    fieldsName="GenderMainstreamingPlan"
                    show={true}
                    disabled={shouldDisableFields}
                    defaultValue={state.TargetInfo?.genderInclusionPlan}
                    onChange={(e) => {
                      setTargetGroupProject({
                        ...TargetGroupProject,
                        genderInclusionPlan: e.target.value,
                      });
                    }}
                    showValidationMessage={
                      state.MainTargetedGroupValidate
                        ? state.MainTargetedGroupValidate.includes(
                            "GenderMainstreamingPlan"
                          )
                        : false
                    }
                    validationMessage="يرجى تعبئة هذا الحقل"
                  />
                </div>
                {/* for render the tables based on P_CountryOfProjectImplementationId  */}
                {state.ProjectInformation
                  ?.aP_CountryOfProjectImplementationId == null ? null : state
                    .ProjectInformation.aP_CountryOfProjectImplementationId ===
                  1 ? (
                  <JordanianGovernoratesProjectActivitiesTable
                    tG_MainTargetedGroupId={
                      state.TargetInfo?.tG_MainTargetedGroupId
                    }
                  />
                ) : state.ProjectInformation
                    .aP_CountryOfProjectImplementationId === 2 ? (
                  <PalestinianGovernoratesProjectActivitiesTable
                    tG_MainTargetedGroupId={
                      state.TargetInfo?.tG_MainTargetedGroupId
                    }
                  />
                ) : (
                  <>
                    <JordanianGovernoratesProjectActivitiesTable
                      tG_MainTargetedGroupId={
                        state.TargetInfo?.tG_MainTargetedGroupId
                      }
                    />
                    <PalestinianGovernoratesProjectActivitiesTable
                      tG_MainTargetedGroupId={
                        state.TargetInfo?.tG_MainTargetedGroupId
                      }
                    />
                  </>
                )}

                {/* <JordanianGovernoratesProjectActivitiesTable
                tG_MainTargetedGroupId={
                  state.TargetInfo?.tG_MainTargetedGroupId
                }
              />
              <PalestinianGovernoratesProjectActivitiesTable
                tG_MainTargetedGroupId={
                  state.TargetInfo?.tG_MainTargetedGroupId
                }
              /> */}
                {/* <div className="form-grid">
              <JordanianGovernoratesProjectActivitiesTable />
              <PalestinianGovernoratesProjectActivitiesTable />
            </div> */}
              </>,
            ]}
          />
        </>
      ) : (
        ""
      )}
      {<LoaderAHSF show={state.loadingUpdateInfoAboutProject} />}

      {!shouldDisableFields ? (
        <div className="containerButtonMAin">
          <ButtonAHSF
            type={"submitter"}
            onClick={() => {
              SaveDataPage(false);
              Swal.fire({
                position: "center",
                icon: "success",
                title: "تم حفظ المعلومات بنجاح",
                showConfirmButton: false,
                timer: 1500,
                // width: "500px",
              });
            }}
            disabled={false}
            title={"حفظ"}
            text={"حفظ"}
            show={true}
          />
          <ButtonAHSF
            type={"submitter"}
            onClick={() => {
              SaveDataPage(true);
            }}
            disabled={false}
            title={"التالي"}
            text={"التالي"}
            show={true}
          />
        </div>
      ) : (
        ""
      )}
      <PopupAHSF
        isPopupOpenStatus={isPopupOpenStatus}
        isPopupOpenFunction={() => setisPopupOpenStatus(false)}
        forValidate={true}
        maxWidth="50%"
        title="يرجى تعبئة الحقول المطلوبة"
        componentBody={state.MainTargetedGroupValidate}
      />
    </>
  );
};

export default InformationTargetGroupProjectModule;
